import { useLang } from '../i18n/LanguageContext';

export default function About() {
  const { t } = useLang();
  return (
    <section id="apropos" data-testid="about-section" className="py-24 bg-white relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative slide-up">
            <div className="relative w-full max-w-md mx-auto">
              <div className="absolute -top-6 left-0 w-24 h-1 bg-brand-yellow rounded-full" />
              <img src="/assets/yuville-logo.png" alt="Yuville International" className="w-full h-auto object-contain" />
            </div>
          </div>

          <div>
            <span className="section-label mb-4">{t('about.label')}</span>
            <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mt-4 mb-6 leading-tight">
              {t('about.title1')} <br />
              <span className="yellow-underline">{t('about.title2')}</span>
            </h2>
            <div data-testid="about-founded-year" className="inline-flex items-center gap-2 mb-5 px-3 py-1 rounded-full bg-brand-yellow/15 border border-brand-yellow text-brand-navy text-xs font-bold tracking-wider uppercase">
              {t('about.foundedIn')}
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">{t('about.p1')}</p>
            <p className="text-gray-700 leading-relaxed mb-8">{t('about.p2')}</p>

            <div className="grid grid-cols-3 gap-6 pt-6 border-t border-gray-200">
              <div>
                <div className="text-3xl md:text-4xl font-bold text-brand-navy">10000+</div>
                <div className="text-sm text-gray-500 mt-1">{t('about.stat1')}</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-brand-navy">16</div>
                <div className="text-sm text-gray-500 mt-1">{t('about.stat2')}</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-brand-navy">6</div>
                <div className="text-sm text-gray-500 mt-1">{t('about.stat3')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
